import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import {
  HomeIcon,
  Cog6ToothIcon,
  ListBulletIcon,
} from "@heroicons/react/24/outline";
import { ReactComponent as LockIcon } from "../../../icons/Menu/Lock.svg";
import useIsMobile from "components/hooks/useIsMobile";

type QuickLink = {
  icon:
    | typeof HomeIcon
    | typeof ListBulletIcon
    | typeof Cog6ToothIcon
    | typeof LockIcon;
  name: string;
  path: string;
};

const QUICK_LINKS: QuickLink[] = [
  { icon: ListBulletIcon, name: "Tasks", path: "/tasks" },
  { icon: LockIcon, name: "Secrets", path: "/secrets" },
  { icon: Cog6ToothIcon, name: "Profile and settings", path: "/settings" },
];

const QuickLinks = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <Box>
      <Typography variant={isMobile ? "h3" : "h4"}>Quick links</Typography>
      <Box sx={{ paddingTop: "13px" }}>
        <List
          sx={{
            border: "1px solid #D4D4D4",
            borderRadius: "8px",
            paddingTop: 0,
            paddingBottom: 0,
            width: "100%",
          }}
        >
          {QUICK_LINKS.map((link, index, array) => {
            return (
              <Fragment key={link.name}>
                <ListItem disablePadding>
                  <ListItemButton
                    dense
                    sx={{
                      height: "60px",
                      paddingTop: 0,
                      paddingBottom: 0,
                      display: "flex",
                      gap: "8px",
                    }}
                    onClick={() => {
                      navigate(link.path);
                    }}
                  >
                    <IconButton aria-label="comments">
                      {<link.icon height="24px" width="24px" />}
                    </IconButton>
                    <ListItemText
                      primary={
                        <Typography color="#3D3D3D" variant="body">
                          {link.name}
                        </Typography>
                      }
                    />
                  </ListItemButton>
                </ListItem>
                {index < array.length - 1 && <Divider />}
              </Fragment>
            );
          })}
        </List>
      </Box>
    </Box>
  );
};

export default QuickLinks;
